<template>
  <div class="dialogGroup_cont">
    <div class="dialogGroup_left no_group">
      <ly-tree
        :gpno="areaId"
        :is_superuser="false"
        :area-tree-type="3"
        :showcount="true"
        :displaynoarea="true"
        @treeClick="treeClick"
      />
    </div>

    <div class="dialogGroup_right">
      <div class="Group_right_header">
        <div class="blue_header">
          <span>{{ $t('ifttt.iftttSelect') }}
            <template>
              （<em>{{ computedIftttCount }}</em>）
            </template>
          </span>
        </div>
        <sort-select
          :value="sortType"
          @change="sortTypeChange"
        />
        <el-divider direction="vertical" />
        <div class="search_way">
          <div class="search_mt">
            <el-input
              v-model="infoSearch"
              :placeholder="$t('ifttt.searchPlhode1')"
              size="medium"
              @keyup.enter.native="doSearchlist"
            />
            <el-button
              class="search_button"
              icon="el-icon-search"
              type="text"
              @click="doSearchlist"
            />
          </div>
        </div>

        <div class="ok_group">
          <span v-if="openType !== 'copy'" class="ok_group_all" @click="handlerSelectIftttAll"> 
            {{ isSelectAll ? $t('sceneCard.clear') : $t('findDevice.selectAll') }}
          </span>
          <template v-if="okCheckNum > 0">
            <el-badge
              :value="okCheckNum"
              class="item"
            >
              <button @click="createGrop">
                {{ nextvalue }}
              </button>
            </el-badge>
          </template>
          <template v-else>
            <button @click="createGrop">
              {{ nextvalue }}
            </button>
          </template>
        </div>
      </div>
      <div class="right_card_box ifttt_body">
        <vuescroll>
          <div
            v-loading="loading"
            class="iftt_box"
            :class="iftttData != null ? (iftttData.length>0 ? '':'card_content_backimage'):''"
          >
            <!-- 复制场景且disabled为true时 不展示 -->
            <template v-for="item in iftttData">
              <div
                v-if="!(item.disabled && openType === 'copy')"
                :key="`${item.GpNo}-${item.IFT_ID}`"
                class="ifttt_list"
                @click="item.disabled?'':checkIfttt(item)"
              >
                <div class="itff_mark">
                  <i class="icon-21" />
                  <span>{{ $t('ifttt.custommode') }}</span>
                </div>
                <el-checkbox
                  v-show="checkShow"
                  v-model="item.ischecked"
                  class="ifttt_checkbox"
                  :disabled="item.disabled"
                  @change="checked => changebox(item, checked)"
                  @click.stop.native="stopBubble"
                />
                <OppleAuth code="CallAuto" :force-show="$store.state.isPassPermission">
                  <button
                    v-if="item.IsManual"
                    class="handle_set"
                    :style="switchShow == true?'':'border: none;margin-top: 8px;'"
                  >
                    {{ $t('ifttt.manual') }}
                  </button>
                  <div
                    v-else
                    class="ifttt_switch"
                  >
                    <v-swith
                      v-if="switchShow"
                      :active-color="activeColor"
                      in-active-color=""
                      :active="item.IsEnable"
                      :is_click="false"
                      @click="checkIfttt(item)"
                    />
                  </div>
                </OppleAuth>
                <button
                  v-if="item.IsManual != true && switchShow != true"
                  class="handle_set"
                  style="border: none;margin-top: 8px;"
                >
                  {{ $t('iftttset.doswitchifttt') }}
                </button>
                <div class="switch_text">
                  <div class="ifttt_title">
                    {{ item.IFT_Name }}
                  </div>
                  <ul class="ifttt_ul">
                    <li>{{ $t('ifttt.status') }}：{{ item.ConfigStatus==1?$t('ifttt.success'):item.ConfigStatus==3?$t('ifttt.fail'):$t('ifttt.ing') }}</li>
                    <li>{{ executionMode(item) }}</li>
                    <li>{{ $t('ifttt.time') }}：{{ item.CreateTime.split('T')[0] }}</li>
                  </ul>
                </div>
                <span
                  v-if="item.havecheck"
                  class="have_state"
                >{{ $t('ifttt.selected') }}</span>
              </div>
            </template>
          </div>
        </vuescroll>
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import vSwith from '@/components/common/switch.vue';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import { FindList,ChooseHclAndIFtttList } from '@/axios/IFttt.js';
import SortSelect from "@/components/select/SortSelect";
import { getSortType } from "@utils/utils";
import select from '../OppleCanvas/canvas/mixins/select';
import { executionMode } from '@/utils/iftttExecute.js';
export default {
	components: {
		vuescroll,vSwith,SortSelect
	},
	props: {   //通过props接收父组件传值
		areaid:{
			type: Number,
			default: -1
		},
		searchtype:{
			type: Number,
			default: 1
		},
		nextText:{
			 type: String,
			 default: ''
		},
		cardNum:{
			type: Boolean,
			default: true
		},
		checkShow:{
		  type: Boolean,
		  default: true
		},
		alreadyCheck:{
			type: Array,
			default() {
				return [];
			}
		},
		switchShow:{
		  type: Boolean,
		  default: true
		},
    // 打开的类型, 'copy': 复制自动化
    openType:{
      type: String,
      default: ''
    },
		iftttmodel:{
			type: Object,
			default: () => {
				return ({})
			}
		}
  },
	data() {
		return {
			areaId:this.areaid,
			infoSearch:'',
			sortType: getSortType(),
			loading:false, //是否加载
			 okCheckNum:0, //选中的数量
			 filterText: '', //未使用
			 allcardNum:0, //设备总数量
			 checkblock: true,//未使用
			 checked:false,//未使用
			 checked1:false,//未使用
			/* is_click:false, */
			/* checkShow:false, */
			 activeColor:'#67c23a', //颜色
			 inActiveColor:'', //开关颜色
			 active:false,//未使用
			 defaultProps: {
				children: 'child',
				label: 'name'
			 },//未使用
			 nextvalue:this.$t('ifttt.yes'), //下一步描述文字
			 iftttData:[], //查询到的自动化
			 checkdata:[], //选中的自动化
			 isSelectAll: false
		};
	},
  computed:{
    // 下一步描述文字
    computedNextText() {
      return this.nextText || this.$t('ifttt.yes')
    },
    // 计算展示的自动化条数
    computedIftttCount() {
      let arr = this.iftttData || []
      // 复制自动化, item.disabled === true 时, 需要隐藏数据
      if(this.openType === 'copy') {
        arr = arr.filter(item => !item.disabled)
      }
      return arr.length
    }
  },
	created() {
	},
	mounted(){
		this.doFindList(this.areaId);
	},
	methods: {
		 //自动化卡片执行方式判断
		executionMode,
		doSearchlist(){
      this.pageIndex=1;
      this.doFindList(this.areaId);
    },
		sortTypeChange(v) {
      this.sortType = v;
      this.pageIndex = 1;
      this.doFindList(this.areaId);
    },
		/* 点击触发选择事件
		* event：事件对象
		*/
		changebox(item, checked) {
			if (this.openType === 'copy') {
				// 复制时单选；再次点击同一项可取消勾选
				this.iftttData.forEach(n => {
					n.ischecked = false
				})
				if (checked) {
					item.ischecked = true
				}
				this.getcheckcount()
				return
			}

			// 原逻辑
			this.getcheckcount()
		},

		/* 获得选中的ifttt
		*/
		getcheckcount(){
			this.okCheckNum=0;
			this.checkdata=[];
			this.iftttData.forEach(n=>{
				if(n.ischecked){
					this.okCheckNum++;
					this.checkdata.push(n);
				}
			})
		},
		/* 点击ifttt触发的事件
		*/
		checkIfttt(item){
			
      // 复制条件下只能单选
      if(this.openType === 'copy') {
        const wasChecked = item.ischecked
        this.iftttData.forEach(n => {
          n.ischecked = false
        })
        if (!wasChecked) {
          item.ischecked = true
        }
        this.getcheckcount()
        return
      }

      // 原始逻辑
			item.ischecked=!item.ischecked;
			this.getcheckcount();
		},
		/* 点击树
		*/
		treeClick(val){
			this.areaId = val[0].id
			this.doFindList(val[0].id);
		},
		/* 获得区域下ifttt设备
		*/
		doFindList(gpno){
			if(gpno!=-1){
				this.loading=true;
				var para={gpNo:gpno,loadMode:0,iftttType:0,iftttName:this.infoSearch};//this.searchtype};
				if (this.sortType !== '') {
					para.sortMode = this.sortType
				}
				ChooseHclAndIFtttList(para,this.functionDoFindList);
				para=null;
			}

		},
		/* 获得区域下ifttt 接口返回数据处理
		* rs：接口返回数据包
		*/
		functionDoFindList(rs){
      console.log('functionDoFindList-rs: ', rs);
			this.loading=false;
			this.iftttData=[];
			if (rs.StatusCode == this.$store.state.rightStatusCode) {
				if(rs.Result){
          if(rs.Result.length>0){
            rs.Result.forEach(n=>{
              var isdel = false;
              for (let i = 0; i < this.alreadyCheck.length; i++) {
                if(this.alreadyCheck[i].ActionType==3){
                  if (n.IFT_ID == this.alreadyCheck[i].IFT_ID) {
                    isdel = true;
                  }
                }
              }
              n.havecheck=isdel; //是否已选
              n.ischecked=false;

              if(this.searchtype == 1 &&  n.IsManual == true){ //手动不能选取
                n.disabled = true;
              }
							

							if((this.iftttmodel && this.iftttmodel.IFtttNo) === n.IFT_ID){
								 n.disabled = true;
							}

              // 复制自动化禁用逻辑处理
              if(this.openType === 'copy') {
                // 非自定义的自动化不能选择
                if(n.IFtttType !== 1) {
                  n.disabled = true
                }

                // 模板会变成多条自定义自动化, 也需要屏蔽, 判断条件GroupId !==IFT_ID, 接口GroupId字段没有赋值的话默认为0
                if(n.GroupId && n.GroupId !== n.IFT_ID) {
                  n.disabled = true
                }

                /**
                 * 自定义(IFtttType === 1)-手动执行, 需要启用选择, 可以复制手动执行的自动化, searchtype不传, 这段逻辑可以不要
                 * 自定义自动化里面, 无法执行手动执行的自动化, 因此禁用了手动执行的自动化
                 */
                if(n.IFtttType === 1 && n.IsManual === true) {
                  n.disabled = false
                }
              }

              this.iftttData.push(n);
            })
          }
				}
			}
		},

		handlerSelectIftttAll() {
			this.isSelectAll = !this.isSelectAll;
			this.iftttData = this.iftttData.map(item => ({
				...item,
				ischecked: item.disabled ? false : this.isSelectAll
			}))

			this.getcheckcount();
		},

		stopBubble(){

		},
		/* 点击确定 将选择的iftt提交给调用页面
		*/
		createGrop(){
			  if(this.checkdata.length>0){
				  this.$emit('confirm',this.checkdata);
			  }else{
				  warning(this,this.$t('ifttt.selectIFTTT'));
			  }

		},
	}
};
</script>

<style scoped="scoped" lang="scss">
/* 自动化选择卡片组件	 */
 .refresh {
    right: 0px;
}

	.ifttt_body{
		.iftt_box{
			.ifttt_list{
				height: 96px;
	            background: #9fbcea;

			   cursor: pointer;
			   .itff_mark{
				  &:after{
					  border-color: transparent #7b9ed5;
				  }
			   }
			   .switch_text{
				   color: #fff;
				   .ifttt_title{
					  margin-top: 12px;
					  padding-bottom: 12px;
					  margin-bottom: 8px;

					  &:after{
					  	  width: 32px;
					      height: 2px;
					  	  background: #fff;
					  }
				   }
			   }
			   .ifttt_switch{
				   top: 32px;
			   }

			   .ifttt_checkbox{
				   top:5px;
				   height: 0px;
			   }
			}
		}
		.ifttt_list{
			background: url(../../assets/img/ift1.png);
			background-repeat: no-repeat;
			background-size: cover;
			cursor: pointer;
			border-radius: 3px;
			position: relative;
			.switch_text{
			  color: #2e2e2e;
			  position: absolute;
			  top: 0px;
			  line-height: 1;
			}
			.ifttt_switch{
				position: absolute;
				top: 70px;
			}
			.itff_mark{
				color: #fff;
				position: relative;
				width: 70px;
				height: 70px;
				z-index: 1;

				font-size: 12px;
				&:after{
					position: absolute;
					content: '';
					width: 0px;
					height: 0px;
					border-color: transparent #5d87e8;
					border-width: 0px 0px 70px 70px;
					border-style: solid;
					left: 0px;
					top: 0px;
				}
				i{
				   color: #fff;
					z-index: 1;
					font-size: 12px;
					position: absolute;
					top: 8px;
					left: 8px;
				}
				span{
				   position: absolute;
					z-index: 1;
					color: #fff;
					width: 75px;
					height: 85px;
					left: 20px;
					top: 5px;
					-webkit-transform: rotate(-45deg);
					-moz-transform: rotate(-45deg);
					-ms-transform: rotate(-45deg);
					-o-transform: rotate(-45deg);
					filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);


				}
			}
		}
	}
	.ifttt_header{
		font-size: 14px;
		background: #fdfdfd;
		height: 105px;
		.ifttt_div{
			display: inline-block;
			color: #181818;
			margin-left: 40px;
			cursor: pointer;
			i{
			   color: #88a7eb;
			   display: inline-block;
			   line-height: 105px;
			   float: left;
			   margin-right: 8px;
			}
			.icon-7{
				font-size: 37px;
			}
			.icon-13{
				font-size: 37px;
			}
			.ifttt_span{
				line-height: 105px;
				em{
					color: #1571ee;
					font-style: normal;
				}
			}
		}
	}

	.have_tree{
		display: block;
		position: absolute;
		top: 0;
		bottom: 0px;
		height: unset;
	}
	.dialogGroup_right{
		.blue_header{
			margin-right: 3em;
		}
		.el-divider {
			margin: 0 2.5em;
			height: 3em;
		}
	}
	.search_way{
		float: none;
		width: 190px;
		margin-top: 0;
	}
	.ok_group_all {
		margin-right: 10px;
		cursor: pointer;
	}
</style>
